export type OrderAction =
  | { type: 'SET_ORDER', order: Julius.Website.OrderViewModel }
  | { type: 'SET_DISCOUNT_RESULT', order: Julius.Website.OrderViewModel }
  | { type: 'SET_ORDER_REQUEST', request: Julius.Website.OrderRequestViewModel }
  | { type: 'SET_SEAT_REQUESTS', seatRequests: Julius.Website.SeatRequestViewModel[] }
  | { type: 'SET_IS_SCATTERED_SEATS', isScatteredSeats: boolean }
  | { type: 'SET_VOUCHER_REQUEST', voucherRequest: Julius.Website.VoucherRequestViewModel }
  | { type: 'SET_IS_MANUAL_RESERVATION', isManualReservation: boolean }
  | { type: 'SET_PERFORMANCE_ID', performanceID: number }
  | { type: 'SET_ORDER_CONFIRMATION', orderConfirmation: Julius.Website.OrderConfirmationViewModel } 
  | { type: 'SET_ORDER_EXPIRE_DATE', expireDate: Date }
  | { type: 'SET_PAYMENT_RESULT', paymentResult: Julius.Website.PaymentResultViewModel }
  | { type: 'SET_SELECTED_PACKAGES', packages: Julius.Website.PackageRequestViewModel[] }
  | { type: 'SET_SELECTED_CUSTOMER_INFO', customerInfo: Julius.Website.CustomerInfoViewModel }
  | { type: 'SET_SELECTED_DELIVERY_CODE', deliveryCode: string }
  | { type: 'SET_SELECTED_PAYMENT_NAME', paymentName: string }
  | { type: 'SET_CUSTOMER_TERMS_APPROVAL', isApproved: boolean }
  | { type: 'ADD_SKANETRAFIKEN_TRAVEL', travel: Julius.Website.TravelRouteViewModel }
  | { type: 'REMOVE_SKANETRAFIKEN_TRAVEL', travel: Julius.Website.TravelRouteViewModel }
  | { type: 'SET_IS_RETRY' }
  | { type: 'SET_IS_FETCHING_ORDER' }
  | { type: 'SET_IS_FETCHING_PAYMENT' }
  | { type: 'SET_IS_FETCHING_DISCOUNT' }
  | { type: 'SET_DISCOUNT_FAILED', order: Julius.Website.OrderViewModel }
  | { type: 'SET_FETCH_ORDER_FAILED' }
  | { type: 'SET_FETCH_PAYMENT_FAILED', isFailed: boolean }
  | { type: 'CLEAR_ORDER' };

export const setOrder = (order: Julius.Website.OrderViewModel): OrderAction => ({
  order,
  type: 'SET_ORDER',
})

export const setDiscountResult = (order: Julius.Website.OrderViewModel): OrderAction => ({ 
  order,
  type: 'SET_DISCOUNT_RESULT',
})

export const setVoucherRequest = (voucherRequest: Julius.Website.VoucherRequestViewModel): OrderAction => ({
  voucherRequest,
  type: 'SET_VOUCHER_REQUEST',
});

export const setSeatRequests = (seatRequests: Julius.Website.SeatRequestViewModel[]): OrderAction => ({
  seatRequests,
  type: 'SET_SEAT_REQUESTS',
});

export const setIsScatteredSeats = (isScatteredSeats: boolean): OrderAction => ({
  isScatteredSeats,
  type: 'SET_IS_SCATTERED_SEATS',
});

export const setOrderRequest = (request: Julius.Website.OrderRequestViewModel): OrderAction => ({
  request,
  type: 'SET_ORDER_REQUEST',
});

export const setIsManualReservation = (isManualReservation: boolean): OrderAction => ({
  isManualReservation,
  type: 'SET_IS_MANUAL_RESERVATION',
});

export const setPerformanceID = (performanceID: number): OrderAction => ({
  performanceID,
  type: 'SET_PERFORMANCE_ID',
});

export const setOrderConfirmation = 
  (orderConfirmation: Julius.Website.OrderConfirmationViewModel): OrderAction => ({
    orderConfirmation,
    type: 'SET_ORDER_CONFIRMATION',
});

export const setOrderExpireDate =
  (expireDate: Date): OrderAction => ({
    expireDate,
    type: 'SET_ORDER_EXPIRE_DATE',
});

export const setPaymentResult = (paymentResult: Julius.Website.PaymentResultViewModel): OrderAction => ({
  paymentResult,
  type: 'SET_PAYMENT_RESULT',
});

export const setSelectedCustomerInfo = 
  (customerInfo: Julius.Website.CustomerInfoViewModel): OrderAction => ({
    customerInfo,
    type: 'SET_SELECTED_CUSTOMER_INFO',
});

export const setSelectedPackages = 
  (packages: Julius.Website.PackageRequestViewModel[]): OrderAction => ({
    packages,
    type: 'SET_SELECTED_PACKAGES',
});

export const setSelectedDeliveryCode = 
  (deliveryCode: string): OrderAction => ({
    deliveryCode,
    type: 'SET_SELECTED_DELIVERY_CODE',
});

export const setSelectedPaymentName = 
  (paymentName: string): OrderAction => ({
    paymentName,
    type: 'SET_SELECTED_PAYMENT_NAME',
});

export const addSkanetrafikenTravel = 
  (travel: Julius.Website.TravelRouteViewModel): OrderAction => ({
    travel,
    type: 'ADD_SKANETRAFIKEN_TRAVEL',
});

export const removeSkanetrafikenTravel = 
  (travel: Julius.Website.TravelRouteViewModel): OrderAction => ({
    travel,
    type: 'REMOVE_SKANETRAFIKEN_TRAVEL',
})

export const setCustomerTermsApproval = 
  (isApproved: boolean): OrderAction => ({
    isApproved,
    type: 'SET_CUSTOMER_TERMS_APPROVAL',
});

export const setDiscountFailed = (order?:Julius.Website.OrderViewModel): OrderAction => ({
  order,
  type: 'SET_DISCOUNT_FAILED',
});

export const setIsFetchingOrder = (): OrderAction => ({
    type: 'SET_IS_FETCHING_ORDER',
});

export const setFetchOrderFailed = (): OrderAction => ({
  type: 'SET_FETCH_ORDER_FAILED',
});

export const setIsFetchingPayment = (): OrderAction => ({
  type: 'SET_IS_FETCHING_PAYMENT',
});

export const setIsFetchingDiscount = (): OrderAction => ({
  type: 'SET_IS_FETCHING_DISCOUNT',
});

export const setFetchPaymentFailed = (isFailed: boolean): OrderAction => ({
  isFailed,
  type: 'SET_FETCH_PAYMENT_FAILED',
});

export const clearOrder = (): OrderAction => ({
  type: 'CLEAR_ORDER',
});

export const setIsRetry = (): OrderAction => ({
  type: 'SET_IS_RETRY',
});


// WEBPACK FOOTER //
// ./src/store/Order/actions.tsx